import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { categories, themes } from '../data/themes';
export function Modeles() {
  const [categorie, setCategorie] = useState('Tous');
  const visibles = themes.filter(t => categorie === 'Tous' || t.categorie === categorie);
  return <main className="mx-auto max-w-6xl px-5 py-12 lg:py-16" data-id="element-223" data-mp="1i1b1k9sznjcc">
      <header className="max-w-2xl" data-id="element-224" data-mp="13dpz8i3xto5h">
        <p className="text-xs uppercase tracking-[0.22em] text-terracotta" data-id="element-225" data-mp="13cet4bn0s4b7">Nos modèles</p>
        <h1 className="mt-3 font-display text-3xl leading-tight text-ink sm:text-4xl" data-id="element-226" data-mp="1869cfdypqh9r">
          Des décors peints pour l’atelier
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-227" data-mp="zce7o71i6sun">
          Sélectionnez un décor pour l’ouvrir directement dans le configurateur — vous pourrez
          ensuite y ajouter votre texte, choisir les chiffres, le format et la finition.
        </p>
      </header>

      <div className="mt-8 flex flex-wrap gap-2" role="group" aria-label="Filtrer par catégorie" data-id="element-228" data-mp="pgb5j16niu7p">
        {categories.map(cat => <button key={cat} type="button" aria-pressed={categorie === cat} onClick={() => setCategorie(cat)} className={`rounded-full border px-4 py-2 text-sm transition-colors duration-150 ease-out ${categorie === cat ? 'border-forest bg-forest text-cream' : 'border-line bg-parchment text-muted hover:border-forest/40 hover:text-ink'}`} data-id="element-229" data-mp="3htv2wzeep87c">
            {cat}
          </button>)}
      </div>

      <ul className="mt-10 grid gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-230" data-mp="3cvjsonk78vol">
        {visibles.map(theme => <li key={theme.id} className="flex flex-col" data-id="element-231" data-mp="3828iqdk3bysg">
            <Link to={`/personnaliser?theme=${theme.id}`} className="group flex h-full flex-col" data-id="element-232" data-mp="2kdpb808v7q1f">
              <img src={theme.image} alt={theme.nom} className="aspect-square w-full scale-105 rounded-full object-cover transition-transform duration-200 ease-out group-hover:scale-110" data-id="element-233" data-mp="2gd5hz7rex6kk" />
              <h2 className="mt-5 font-display text-xl text-ink" data-id="element-234" data-mp="o99gsn04w61c">{theme.nom}</h2>
              <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-235" data-mp="t2b2bduuj3tw">{theme.description}</p>
              <span className="mt-auto inline-flex items-center gap-1.5 pt-4 text-sm text-forest" data-id="element-236" data-mp="xzkpsnyod5f3">
                Personnaliser ce décor
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-237" data-mp="fhz8otzhsgq" />
              </span>
            </Link>
          </li>)}
      </ul>
    </main>;
}